import { useStoreState } from 'providers/StoreStateContext';
import { PropsWithChildren, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

type PublicRouteProps = PropsWithChildren;

const BLOCKED_REDIRECTS = ['/label-form', '/security', '/login'];

export default function PublicRoute({ children }: PublicRouteProps) {
  const { token, tokenData, redirectPath, setRedirectPath } = useStoreState();
  const navigate = useNavigate();

  useEffect(() => {
    if (!tokenData) return;

    if (redirectPath) {
      const isBlocked = BLOCKED_REDIRECTS.includes(redirectPath);
      const target = isBlocked ? '/' : redirectPath;

      navigate(target, { replace: true });

      setRedirectPath(null);
    }

    if (!redirectPath) {
      navigate('/', { replace: true });
    }
  }, [tokenData, token]);

  return <Outlet />;
}
